export const XS = 'xs';
export const SM = 'sm';
export const MD = 'md';
export const LG = 'lg';
export const XL = 'xl';

export const XS_MIN_WIDTH = 575;

export const SM_MIN_WIDTH = 576;
export const SM_MAX_WIDTH = 767;

export const MD_MIN_WIDTH = 768;
export const MD_MAX_WIDTH = 991;

export const LG_MIN_WIDTH = 992;
export const LG_MAX_WIDTH = 1199;

export const XL_MIN_WIDTH = 1200;

export const MAX_MOBILE_WIDTH = 480;
export const MIN_MOBILE_WIDTH = 360;

export const USER_DEVICE_MOBILE = 'Mobile';
export const USER_DEVICE_TABLET = 'Tablet';
export const USER_DEVICE_LAPTOP = 'Laptop';
